module.exports = __webpack_public_path__ + "img/71.f151839b.jpg";